// The page shown for a sitemap screen that is not built yet. It says which
// work package builds it and links to anything that already does part of the
// job. The e2e route-smoke spec recognises it by data-stub.
import { Link, useParams } from "react-router";
import { useMeta } from "../api/meta";
import { Notice } from "../ui/Notice";
import { PageHeader } from "../ui/PageHeader";
import { coverageRow, WP_LABELS } from "./coverage";
import type { PlaceholderLink } from "./types";

function fill(to: string, params: Record<string, string | undefined>): string {
  return to.replace(/:(\w+)/g, (m, k: string) => params[k] ?? m);
}

export function Placeholder({ screens, links = [] }: { screens: number[]; links?: PlaceholderLink[] }) {
  const params = useParams();
  const meta = useMeta();
  const rows = screens.map(coverageRow);
  const first = rows[0];
  const names = rows.map((r) => r.screen).join(" / ");
  return (
    <div className="placeholder-page" data-stub={first.wp}>
      <PageHeader title={names} documentTitle={names} lead={`This screen of ${meta.appName} is being built.`} />
      <Notice kind="info" title={`Being built by the ${WP_LABELS[first.wp].toLowerCase()} work package`}>
        <p>
          Screen {rows.map((r) => `#${r.n}`).join(", ")} of the site map, owned by work package “{first.wp}” (apps/web/src/areas/{first.wp}).
        </p>
      </Notice>
      {links.length ? (
        <div className="placeholder-page__links">
          <h2>Until then</h2>
          <ul>
            {links.map((l) => (
              <li key={l.to}>
                <Link to={fill(l.to, params)}>{l.label}</Link>
              </li>
            ))}
          </ul>
        </div>
      ) : null}
    </div>
  );
}
